let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("95wwu")).then(() => parcelRequire('iTwYh'));